import { Injectable } from '@angular/core';

import { tap } from 'rxjs/operators';

import { BehaviorSubject, Observable } from 'rxjs';

import { HttpClientExtension } from '../../../common/services/http-client-extension.service';
import { OperationConfirmation } from '../../../shared/confirmation/core/models/operation-confirmation.model';
import { OtpConfirmation } from '../../authorization.model';

import { PreloginProduct } from './models/models';

interface CreateSessionRequest {
	firstName: string;
	lastName: string;
	patronymic?: string;
	mobileNumber: string;
	productId: number;
	deviceId?: string;
	sysName: string;
	ipAddress?: string;
	deviceOS?: string;
	deviceType?: string;
	deviceModel?: string;
	appVersion?: string;
}
export interface CreateSessionResponse {
	authorized: boolean;
}

export interface BiometricsRegistrationCreateRequestAgreement {
	code: string;
	isAgree: string;
}
export interface BiometricsRegistrationCreateRequest {
	agreements: Array<BiometricsRegistrationCreateRequestAgreement>;
}

export interface BiometricsRegistrationCreateResponse extends OtpConfirmation {
	confirmType: string;
}

export interface CreateAdapterSessionResponse {
	redirectUrl: string;
}

export interface GetVerificationInfoResponse {
	'lastName': string;
	'firstName': string;
	'middleName': string;
	'birthDate': Date;
	'gender': string;
	'issueDate': Date;
	'docSeries': string;
	'docNumber': string;
	'issuedBy': string;
	'snils': string;
	'mobilePhone': string;
	'email': string;
}

export interface BiometricsCreateClientConfirmResponse {
	/** Ид клиента */
	clientId: number;
	/** Ид анкеты */
	contractId: number;
	/** номер телефона */
	mobile: string;
	/** логин */
	login: string;
}

@Injectable()
export class BiometricsRegistrationWizardService {

	public readonly productIdForGetPreloginProducts = '9d0cd023';
	public readonly getLoadedPreloginProducts$$ = new BehaviorSubject<Array<PreloginProduct> | null>(null);

	public url: string = 'rest/prelogin/card/products';

	constructor(private http: HttpClientExtension) { }

	public getPreloginProducts(productId: string): Observable<Array<PreloginProduct>> {
		return this.http.get<Array<PreloginProduct>>(this.url, {params: {id: productId}})
			.pipe(
				tap((x: Array<PreloginProduct>) => {
					this.getLoadedPreloginProducts$$.next(x);
				}),
			);
	}

	public createSession(data: CreateSessionRequest): Observable<CreateSessionResponse> {
		return this.http.post<CreateSessionResponse>('rest/prelogin/session/create', data);
	}

	public create(data: BiometricsRegistrationCreateRequest): Observable<BiometricsRegistrationCreateResponse> {
		return this.http.post<BiometricsRegistrationCreateResponse>('rest/prelogin/biometry/create', data);
	}

	public confirm(
		operationConfirmation: OperationConfirmation,
	): Observable<void> {
		return this.http.post<void>('rest/prelogin/biometry/confirm', operationConfirmation);
	}

	public loadDocument(): Observable<Blob> {
		return this.http.get<Blob>('rest/prelogin/document/pdf', {responseType: 'blob' as 'json'});
	}

	public createAdapterSession(): Observable<CreateAdapterSessionResponse> {
		return this.http.post<CreateAdapterSessionResponse>('rest/prelogin/adapter/session/create', {});
	}

	public getVerificationInfo(secret: string): Observable<GetVerificationInfoResponse> {
		return this.http.post<GetVerificationInfoResponse>('rest/prelogin/verification/get-info', {resSecret: secret});
	}

	public updateVerificationInfo(email: string): Observable<void> {
		return this.http.post<void>('rest/prelogin/verification/update-info', {email});
	}

	public verificationLog(logData: string): Observable<void> {
		return this.http.post<void>('rest/prelogin/verification/log-result', {'redirectUrl': logData});
	}

	public loadOfferDocument(): Observable<Blob> {
		return this.http.post<Blob>('rest/prelogin/document/sign', {}, {responseType: 'blob' as 'json'});
	}
	public createClietntCreate(): Observable<OtpConfirmation> {
		return this.http.post<OtpConfirmation>('rest/prelogin/client/create', {});
	}
	public createClientConfirm(
		operationConfirmation: OperationConfirmation,
	): Observable<BiometricsCreateClientConfirmResponse> {
		return this.http.post<BiometricsCreateClientConfirmResponse>('rest/prelogin/client/confirm', operationConfirmation);
	}

}
